<template>
  <!-- Begin Page Content -->
  <div class="container" v-if="parent">
    <!-- Page Heading -->
    <div class="d-sm-flex align-items-center justify-content-between mb-4">
      <h1 class="h3 mb-0 text-gray-800">{{ parent.name }}</h1>
    </div>

    <v-row justify="space-around">
      <v-col
        v-for="(category, index) in categories"
        :key="index"
        cols="4"
        lg="1"
        md="1"
        sm="2"
        class="px-0"
      >
        <v-img
                 width="70"
              class="mx-auto"
          style="cursor: pointer"
          :src="_getImage(category)"
          @click="
            $router.push({
              name: 'SubCategoryItems',
              params: { categoryId: categoryId, typeId: category.id },
            })
          "
        />
        <p class="text-center">{{ category.name }}</p>
      </v-col>
    </v-row>

    <hr />
    <div class="row">
      <div class="col col-12">
        <button
          class="btn btn-sm btn-block btn-secondary"
          @click="showFilter = !showFilter"
        >
          Шүүлтүүр
        </button>
      </div>
    </div>
    <div v-if="showFilter == true" class="my-4 border border-primary rounded">
      <div class="p-3">
        <div class="row">
          <div class="h4 col col-expand">{{ parent.name }}</div>
          <div class="col col-auto">
            <button
              class="btn btn-outline-secondary btn-sm mr-2"
              @click="resetFilter"
            >
              Арилгах
            </button>
            <button class="btn btn-success btn-sm" @click="filterItems">
              Хайх
            </button>
          </div>
        </div>
        <hr />
        <div>
          <div class="row my-3">
            <div class="col col-expand">
              <input
                v-model="filterText"
                type="text"
                class="form-control"
                placeholder="Хайлт"
              />
            </div>
            <!-- <div class="col col-auto">
              <button class="btn btn-success">Search</button>
            </div> -->
          </div>
        </div>
        <div class="row">
          <div class="col-md-3 col-sm-12 my-3">
            Төлөв
            <div class="custom-control custom-radio">
              <input
                type="radio"
                id="customRadio1"
                name="customRadio"
                class="custom-control-input"
                :value="true"
                v-model="isnew"
              />
              <label class="custom-control-label" for="customRadio1"
                >Шинэ</label
              >
            </div>
            <div class="custom-control custom-radio">
              <input
                type="radio"
                id="customRadio2"
                name="customRadio"
                class="custom-control-input"
                :value="false"
                v-model="isnew"
              />
              <label class="custom-control-label" for="customRadio2"
                >Хуучин</label
              >
            </div>
          </div>

          <div class="col-md-3 col-sm-12 my-3">
            Суурилуулалт
            <div class="custom-control custom-radio">
              <input
                type="radio"
                id="mountRadio"
                name="mountRadio"
                class="custom-control-input"
                :value="true"
                v-model="mount"
              />
              <label class="custom-control-label" for="mountRadio">Тийм</label>
            </div>
            <div class="custom-control custom-radio">
              <input
                type="radio"
                id="mountRadio2"
                name="mountRadio2"
                class="custom-control-input"
                :value="false"
                v-model="mount"
              />
              <label class="custom-control-label" for="mountRadio2">Үгүй</label>
            </div>
          </div>
          <div class="col-md-3 col-sm-12 my-3">
            Хүргэлт
            <div class="custom-control custom-radio">
              <input
                type="radio"
                id="shippingRadio"
                name="shippingRadio"
                class="custom-control-input"
                :value="true"
                v-model="shipping"
              />
              <label class="custom-control-label" for="shippingRadio"
                >Тийм</label
              >
            </div>
            <div class="custom-control custom-radio">
              <input
                type="radio"
                id="shippingRadio2"
                name="shippingRadio2"
                class="custom-control-input"
                :value="false"
                v-model="shipping"
              />
              <label class="custom-control-label" for="shippingRadio2"
                >Үгүй</label
              >
            </div>
          </div>
          <div
            class="col-md-3 col-sm-12 my-3"
            v-if="
              parent.side != null &&
              parent.side != undefined &&
              parent.side != null &&
              parent.side == true
            "
          >
            Байрлал
            <div class="custom-control custom-radio">
              <input
                type="radio"
                id="sideRadio"
                name="sideRadio"
                class="custom-control-input"
                :value="'right'"
                v-model="side"
              />
              <label class="custom-control-label" for="sideRadio">Баруун</label>
            </div>
            <div class="custom-control custom-radio">
              <input
                type="radio"
                id="sideRadio2"
                name="sideRadio2"
                class="custom-control-input"
                :value="'left'"
                v-model="side"
              />
              <label class="custom-control-label" for="sideRadio2">Зүүн</label>
            </div>
          </div>
          <div
            class="col-md-3 col-sm-12 my-3"
            v-if="
              parent.vside != null &&
              parent.vside != undefined &&
              parent.vside != null &&
              parent.vside == true
            "
          >
            Байрлал
            <div class="custom-control custom-radio">
              <input
                type="radio"
                id="vsideRadio"
                name="vsideRadio"
                class="custom-control-input"
                :value="'front'"
                v-model="vside"
              />
              <label class="custom-control-label" for="vsideRadio">Урд</label>
            </div>
            <div class="custom-control custom-radio">
              <input
                type="radio"
                id="vsideRadio2"
                name="vsideRadio2"
                class="custom-control-input"
                :value="'back'"
                v-model="vside"
              />
              <label class="custom-control-label" for="vsideRadio2">Хойд</label>
            </div>
          </div>
          <div class="col-md-3 col-sm-12 my-3">
            Эрэмбэлэх
            <div class="custom-control custom-radio">
              <input
                type="radio"
                id="sortRadio"
                name="sortRadio"
                class="custom-control-input"
                :value="'date,desc'"
                v-model="sortby"
              />
              <label class="custom-control-label" for="sortRadio"
                >Сүүлд нэмсэнээр</label
              >
            </div>
            <div class="custom-control custom-radio">
              <input
                type="radio"
                id="sortRadio2"
                name="sortRadio2"
                class="custom-control-input"
                :value="'price,desc'"
                v-model="sortby"
              />
              <label class="custom-control-label" for="sortRadio2"
                >Үнэтэй нь эхэндээ</label
              >
            </div>
            <div class="custom-control custom-radio">
              <input
                type="radio"
                id="sortRadio3"
                name="sortRadio3"
                class="custom-control-input"
                :value="'price,asc'"
                v-model="sortby"
              />
              <label class="custom-control-label" for="sortRadio3"
                >Хямд нь эхэндээ</label
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <hr />
    <div v-if="searched == false">
      <div class="text-center text-primary text-lg">
        <p v-if="parent && parent.numberOfItems">
          Нийт {{ parent.numberOfItems }} сэлбэг
        </p>
      </div>

      <div class="row my-5">
        <div class="col col-12 my-3" v-for="(item, index) in items">
          <div class="card">
            <div class="card-body">
              <p
                class="font-weight-bold text-dark text-lg"
                v-if="item.shortCategory"
              >
                <span v-if="item.shortCategory.category">{{
                  item.shortCategory.category
                }}</span>
                <span v-if="item.shortCategory.type"
                  >/{{ item.shortCategory.type }}</span
                >
                <span v-if="item.shortCategory.subtype"
                  >/{{ item.shortCategory.subtype }}</span
                >
              </p>
              <div class="d-flex">
                <img
                  style="border-radius: 5%; height: 160px"
                  v-if="_getImage(item)"
                  :src="_getImage(item)"
                  alt=""
                />
                <div class="mx-3 flex-fill">
                  <p class="font-weight-bold">
                    {{ index + 1 }}. {{ item.name }}
                  </p>

                  <p class="" v-if="item.shortCarType">
                    <span v-if="item.shortCarType.cartype">{{
                      item.shortCarType.cartype
                    }}</span>
                    <span v-if="item.shortCarType.carmark"
                      >/{{ item.shortCarType.carmark }}</span
                    >
                    <span v-if="item.shortCarType.aral"
                      >/{{ item.shortCarType.aral }}</span
                    >
                    <span v-if="item.shortCarType.caryear"
                      >/{{ item.shortCarType.caryear }}</span
                    >
                    <span v-if="item.shortCarType.carmodel"
                      >/{{ item.shortCarType.carmodel }}</span
                    >
                  </p>
                  <div class="row justify-content-between">
                    <div class="col col-md-6 col-sm-12">
                      <div v-if="item.storeData">
                        <span
                          class="text-primary font-weight-bold"
                          v-if="item.storeData.name"
                          >{{ item.storeData.name }}</span
                        >
                        <br />
                        <p class="" v-if="item.storeData.shortAddress">
                          <span v-if="item.storeData.shortAddress.city">{{
                            item.storeData.shortAddress.city
                          }}</span>
                          <span v-if="item.storeData.shortAddress.district"
                            >/{{ item.storeData.shortAddress.district }}</span
                          >
                          <span v-if="item.storeData.shortAddress.horoo"
                            >/{{ item.storeData.shortAddress.horoo }}</span
                          >
                          <span v-if="item.storeData.address"
                            >/{{ item.storeData.address }}</span
                          >
                        </p>
                      </div>
                    </div>
                    <div class="col col-md-6 col-sm-12">
                      <div style="text-align: end">
                        <span
                          class="badge badge-success"
                          v-if="item.mount == true"
                          >Суурилуулалттай</span
                        >
                        <span class="badge badge-danger" v-else
                          >Суурилуулалтгүй</span
                        >
                      </div>
                      <div style="text-align: end">
                        <span
                          class="badge badge-success"
                          v-if="item.shipping == true"
                          >Хүргэлттэй</span
                        >
                        <span class="badge badge-danger" v-else
                          >Хүргэлтгүй</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col" v-if="end != true">
          <button
            @click.prevent="getItems"
            class="btn btn-success btn-sm btn-block"
          >
            Цааш нь үзэх
          </button>
        </div>
      </div>
    </div>

    <!-- Filter -->
    <div v-if="searched == true">
      <div class="text-center text-primary text-lg">
        <p v-if="filterCount">Нийт хайлтаар илэрсэн {{ filterCount }} сэлбэг</p>
        <p v-else>Хайлтанд тохирох сэлбэг олдсонгүй.</p>
      </div>

      <div class="row my-5">
        <div class="col col-12 my-3" v-for="(item, index) in filteredItems">
          <div class="card">
            <div class="card-body">
              <p class="font-weight-bold text-dark text-lg" v-if="item">
                <span v-if="item.category">{{ item.category }}</span>
                <span v-if="item.type">/{{ item.type }}</span>
                <span v-if="item.subtype">/{{ item.subtype }}</span>
              </p>
              <div class="d-flex">
                <img
                  style="border-radius: 5%; height: 160px"
                  v-if="_getFilterImage(item)"
                  :src="_getFilterImage(item)"
                  alt=""
                />
                <div class="mx-3 flex-fill">
                  <p class="font-weight-bold">
                    {{ index + 1 }}. {{ item.name }}
                  </p>

                  <p class="" v-if="item">
                    <span v-if="item.cartype">{{ item.cartype }}</span>
                    <span v-if="item.carmark">/{{ item.carmark }}</span>
                    <span v-if="item.aral">/{{ item.aral }}</span>
                    <span v-if="item.caryear">/{{ item.caryear }}</span>
                    <span v-if="item.carmodel">/{{ item.carmodel }}</span>
                  </p>
                  <div class="row justify-content-between">
                    <div class="col col-md-6 col-sm-12">
                      <div v-if="item">
                        <span
                          class="text-primary font-weight-bold"
                          v-if="item.ownerName"
                          >{{ item.ownerName }}</span
                        >
                        <br />
                        <p class="" v-if="item.shortAddress">
                          <span v-if="item.shortAddress">{{
                            item.shortAddress
                          }}</span>
                        </p>
                      </div>
                    </div>
                    <div class="col col-md-6 col-sm-12">
                      <div style="text-align: end">
                        <span
                          class="badge badge-success"
                          v-if="item.mount == true"
                          >Суурилуулалттай</span
                        >
                        <span class="badge badge-danger" v-else
                          >Суурилуулалтгүй</span
                        >
                      </div>
                      <div style="text-align: end">
                        <span
                          class="badge badge-success"
                          v-if="item.shipping == true"
                          >Хүргэлттэй</span
                        >
                        <span class="badge badge-danger" v-else
                          >Хүргэлтгүй</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col" v-if="filterend != true">
          <button
            @click.prevent="filterNextPage()"
            class="btn btn-success btn-sm btn-block"
          >
            Цааш нь үзэх...
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- /.container-fluid -->
</template>

<script>
const fb = require("../../firebaseConfig.js");
import Vue from "vue";
import { mapState } from "vuex";
import axios from "axios";
export default {
  name: "CategoryItems",
  data() {
    return {
      parent: null,
      categories: [],
      items: [],
      firstVisible: null,
      lastVisible: null,
      end: false,
      isnew: null,
      mount: null,
      shipping: null,
      side: null,
      vside: null,
      colors: [],
      sortby: null,
      showFilter: false,
      spage: 0,
      spagesize: 20,
      searched: false,
      filteredItems: [],
      filterend: false,
      filterText: null,
      filterCount: null,
    };
  },
  methods: {
    getCategories() {
      fb.db
        .collection("selbegtypes")
        .doc(this.categoryId)
        .get()
        .then((value) => {
          if (value && value.exists) {
            let item = value.data();
            item.id = value.id;
            this.parent = item;
            this.getItems();
          }
        });
      fb.db
        .collection("selbegtypes")
        .doc(this.categoryId)
        .collection("children")
        .orderBy("createdAt")
        .get()
        .then((docs) => {
          if (docs && !docs.empty) {
            this.categories = [];
            docs.docs.forEach((value) => {
              if (value && value.exists) {
                let item = value.data();
                item.id = value.id;
                this.categories.push(item);
              }
            });
          }
        });
    },
    async getItems() {
      if (this.parent && this.parent.id) {
        if (this.end != true) {
          var querySnapshot;
          var first = false;
          if (this.lastVisible == null) {
            querySnapshot = await fb.db
              .collectionGroup("selbeg")
              .where(
                "category",
                "==",
                fb.db.collection("selbegtypes").doc(this.categoryId)
              )
              .where("active", "==", true)
              .orderBy("createdAt", "desc")
              .limit(30)
              .get();
            if (querySnapshot != null && !querySnapshot.empty) {
              this.firstVisible = querySnapshot.docs[0];
              first = true;
            }
          } else {
            querySnapshot = await fb.db
              .collectionGroup("selbeg")
              .where(
                "category",
                "==",
                fb.db.collection("selbegtypes").doc(this.categoryId)
              )
              .where("active", "==", true)
              .orderBy("createdAt", "desc")
              .startAfter(this.lastVisible)
              .limit(30)
              .get();
          }

          if (querySnapshot != null && !querySnapshot.empty) {
            if (
              first == true ||
              (first != null &&
                this.firstVisible.id != null &&
                this.firstVisible.id != querySnapshot.docs[0].id)
            ) {
              // console.log("abc");
              for (const itemDoc of querySnapshot.docs) {
                let item = itemDoc.data();
                item.id = itemDoc.id;
                item.storeData = null;
                if (item.store) {
                  item.store.get().then((storeDoc) => {
                    if (storeDoc && storeDoc.exists) {
                      item.storeData = storeDoc.data();
                    }
                  });
                }
                // console.log(item);
                this.items.push(item);
              }
              this.lastVisible =
                querySnapshot.docs[querySnapshot.docs.length - 1];
            } else this.end = true;
          }
        }
      }
    },
    filterItems() {
      this.searched = true;
      this.filteredItems = [];
      this.spage = 0;
      this.filterCount = null;
      this.filterend = false;
      this.getFilterItems();
    },
    filterNextPage() {
      if (this.filterend != true) {
        this.searched = true;
        this.spage++;
        this.getFilterItems();
      }
    },
    async getFilterItems() {
      var tmp = {};
      tmp["page"] = this.spage;
      tmp["size"] = this.spagesize;
      tmp["categoryId"] = this.categoryId;
      if (
        this.filterText &&
        this.filterText.trim() != "" &&
        this.filterText.length > 2
      ) {
        tmp["value"] = this.filterText;
      }
      if (this.sortby && this.sortby != "") {
        tmp["sort"] = this.sortby;
      }
      if (this.isnew != null && this.isnew != undefined) {
        tmp["isNew"] = this.isnew;
      }
      if (this.mount != null) {
        tmp["mount"] = this.mount;
      }
      if (this.shipping != null) {
        tmp["shipping"] = this.shipping;
      }
      // if(colors!=null && colors.length>0){
      //   tmp['colorId']=colors;
      // }
      if (this.side != null && this.side != "") {
        tmp["side"] = this.side;
      }
      if (this.vside != null && this.vside != "") {
        tmp["vside"] = this.vside;
      }
      axios
        .get(fb.searchUrl + "/filter", {
          params: tmp,
        })
        .then((response) => {
          this.searched = true;
          // console.log(response);
          if (
            response &&
            response.data &&
            response.data.content &&
            response.data.content.length > 0
          ) {
            if (response.data.totalElements) {
              this.filterCount = response.data.totalElements;
            }
            for (const object of response.data.content) {
              this.filteredItems.push(object);
            }
            if (response.data.last == true) this.filterend = true;
          }
        });
    },
    resetFilter() {
      this.filterText = null;
      this.filterend = false;
      this.filteredItems = [];
      this.searched = false;
      this.spage = 0;
      this.isnew = null;
      this.mount = null;
      this.shipping = null;
      this.side = null;
      this.vside = null;
      this.colors = [];
      this.sortby = null;
    },
    _getImage(obj) {
      if (obj.images != null && obj.images != undefined) {
        return obj.images[0]["fileUrl"];
      }
      return null;
    },
    _getFilterImage(obj) {
      if (obj.imageUrl) {
        return obj.imageUrl;
      }
      return null;
    },
  },
  props: {
    categoryId: {
      required: true,
    },
  },
  created() {
    this.getCategories();
  },
};
</script>

